<template>
  <div class="main">
    <Header />
    <keep-alive include="make,real">
      <router-view />
    </keep-alive>
    <!-- 登录组件 -->
    <Login v-show="showlogin" />
    <!-- 开通会员组件 -->
    <!-- <OpenVip v-if="show_openvip" /> -->
  </div>
</template>

<script>
import Header from "./components/header";
import Login from "./components/login";
import OpenVip from "./components/openvip.vue";
import { mapState } from "vuex";
export default {
  name: "App",
  components: {
    Header,
    Login,
    OpenVip,
  },
  computed: {
    ...mapState(["showlogin", "userinfo", "userrich", "show_openvip"]),
  },
  mounted() {
    this.setQd()
    this.bootUp()
    this.$globalFun.getUserInfo(this);
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.$globalFun.goTop()
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    // 获取get参数方法
    getQueryVariable(variable) {
      let href = window.location.href
      let query = href.substring(href.indexOf('?') + 1);
      let vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    },
    // 从设备启动函数中获取信息
    bootUp() {
      let self = this;
      let url = this.$store.state.base_api + this.$store.state.base_url.bootup;
      this.$request.postHttp({ active: "2" }, url, (response) => {
        console.log('bootup', response)
        self.$store.commit(
          "setZifubao",
          JSON.parse(response.model.appcfg).zifubao
        );
        self.$store.commit(
          "setJbList",
          JSON.parse(response.model.jbrechargelist)
        );
        self.$store.commit(
          "setTtsJbList",
          JSON.parse(response.model.ttsjblist)
        );
      });
    },
    // 设置渠道号
    setQd() {
      let from = this.getQueryVariable('from').split('#')[0].replace('/', '')
      if (from) localStorage.setItem("qd", from);
    }
  },
};
</script>

<style>
/* 初始化css */
@import url("./assets/css/reset.css");
/* 全局css */
@import url("./assets/css/style.css");
/* 首页css */
@import url("./assets/css/index.css");
/* 真人配音css */
@import url("./assets/css/real.css");
@import url("./assets/css/dubbing.css");
/* 关于我们css */
@import url("./assets/css/aboutUs.css");
/* 720p屏幕适配样式 */
@import url("./assets/css/style_720p.css");
</style>



// WEBPACK FOOTER //
// src/App.vue